import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Dropdown, DropdownButton, Container, Row} from "react-bootstrap";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { testJSON } from '../utils/jsUtils';


const ModelAdmin_NewModelView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [modelAttrs, setModelAttrs] = useState({
    id: '',
    name: '',
    description: '',
    version: '',
    config: '',
    status: ''
  });

  const statusOptions = [
    { key: "ST_ENABLED",  value: "ST_ENABLED" },
    { key: "ST_DISABLED", value: "ST_DISABLED" }
  ];


  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setModelAttrs({ ...modelAttrs, [e.target.name]: e.target.value })
  }

  const onStatusSelect = (key, event) => {
    setModelAttrs({ ...modelAttrs, status: key });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!modelAttrs.name || modelAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
    } else if (modelAttrs.name.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_name") + "50");
    } else {
      validateName();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("3d-models?name=" + modelAttrs.name);

        resolve(res.data);

        if ((res.status === 200) && (res.data.length > 0)) {
          // Model name is taken
          setErrMsg(t("I18N_ERR_Name_taken"));
          return;
        } else {
          validateOtherFields();
          return;
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs

    if (!modelAttrs.description || modelAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (modelAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + "200");

    } else if (!modelAttrs.version || modelAttrs.version.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_version"));
    } else if (modelAttrs.version.length > 20) {
      setErrMsg(t("I18N_ERR_Max_len_version") + "20");

    } else if (!modelAttrs.status || modelAttrs.status.length === 0) {
      setErrMsg(t("I18N_ERR_Need_status"));

    } else if (!modelAttrs.config || modelAttrs.config.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_config"));
    } else if (   (modelAttrs.config !== '')
               && (!testJSON(modelAttrs.config))) {
      // Validate configuration to be valid JSON
      setErrMsg(t("I18N_ERR_Config_need_valid_JSON"));
    } else {
      createNewModel();
    }
  }

  const createNewModel = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(modelAttrs));
    reqBody.config = JSON.parse(modelAttrs.config);

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("3d-models", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_3dModel")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_3dModel_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col md={3}>{t("I18N_Name")}: *</Col>
              <Col md={3}>{t("I18N_Description")}: *</Col>
              <Col md={3}>{t("I18N_Version")}: *</Col>
              <Col md={3}>{t("I18N_Status")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} name="name" value={modelAttrs.name}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={modelAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <input className={classes.admin_pages__field_editable} name="version" value={modelAttrs.version}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!modelAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") :
                          t("I18N_" + (statusOptions.find( ({ key }) => key === modelAttrs.status )).value)}
                  onSelect={onStatusSelect}>
                  {statusOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col md={3}>{t("I18N_3d_model_config")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col sm={{span: 12}}>
                <textarea className={classes.admin_pages__field_editable} rows={10} style={{minWidth: '100%'}} name="config"
                          value={modelAttrs.config} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}
 
export default ModelAdmin_NewModelView;
